import { Accordion, Box, Icon, Text } from '@nimbus-ds/components';
import getMockArrayForSkeleton from 'commons/utils/getMockArrayForSkeleton';
import './OnboardingAccordionTasks.scss';

function Skeleton() {
  return (
    <div className="stratus--onboarding-accordion-tasks">
      <Accordion>
        {getMockArrayForSkeleton(4).map((id, index) => (
          <Accordion.Item key={id} index={`${id}`}>
            <Box
              display="flex"
              alignItems="center"
              gap="2"
              borderTopWidth={index > 0 ? '1' : undefined}
              borderStyle={index > 0 ? 'solid' : undefined}
              borderColor={index > 0 ? 'neutral-surfaceHighlight' : undefined}
              paddingTop="2"
              paddingBottom="2"
              paddingLeft="4"
              paddingRight="4"
            >
              <Box display="flex" justifyContent="center" alignItems="center">
                <Icon.Skeleton height="28px" width="28px" />
              </Box>
              <Text.Skeleton width="150px" />
            </Box>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
}

export default Skeleton;
